import { LandingPageListCSSStyleImpl } from './landingpagelistcss';
import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { LandingPageListViewImpl } from './landingpagelistview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { FeaturedCategoryDto } from '../../../../core/dto/featuredcategory/featuredcategorydto';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { CRBTUIComponent, CRBTUIComponentProps } from '../crbt/crbtuicomponent';
import { LandingPageListAPIModel, LandingPageListAPIModelImpl } from './landingpageapimodel';

export interface LandingPageListComponentProps extends CRBTUIComponentProps {
    categoryName: string;
    categoryId?: number;
    language: string;
}

export interface LandingPageListComponentState extends UIComponentState {
    isDataNotLoaded: boolean;
}

export interface LandingPageListComponentHandler extends UIComponentHandler {
    onDataNotLoaded(isNotLoaded: boolean): void;
    loadMore(categoryId: number, title: string, startIndex: number, offset: number, language: string): void;
    refreshTabData(title: string): void;
}

export class LandingPageListComponent extends CRBTUIComponent<LandingPageListComponentProps, LandingPageListComponentState>
    implements LandingPageListComponentHandler {

    // 1. Private fields are grouped at the very top
    private count: number = 0;
    private isLoadMore: boolean = false;

    // 2. Constructor comes next
    constructor(props: LandingPageListComponentProps) {
        super(props);
        this.state = { isDataNotLoaded: false };
    }

    // 3. React Lifecycle methods (Public)
    componentDidMount() {
    }

    componentWillReceiveProps(nextProps: LandingPageListComponentProps) {
        if (nextProps.categoryId !== this.props.categoryId&& nextProps.categoryName !== this.props.categoryName) {
            this.initialDataFetch(nextProps);
        }
    }

    // 4. Public Handler / Class methods
    onDataNotLoaded(isNotLoaded: boolean): void {
        this.setState({ isDataNotLoaded: isNotLoaded });
    }

    getAPIModel(): LandingPageListAPIModel {
        return (super.getAPIModel() as LandingPageListAPIModel);
    }

    loadMore(categoryId: number, title: string, startIndex: number, offset: number, language: string): void {
        this.isLoadMore = true;
        (this.getView() as LandingPageListViewImpl).showLoader();
        this.getAPIModel().getLoadMoreFeatureLandingPageTones(categoryId, title, startIndex, offset, language);
    }

    refreshTabData(title: string): void {
        this.isLoadMore = false;
        (this.getView() as LandingPageListViewImpl).showLoader();
    }

    // FIX: This public method is now grouped alongside other public methods
    updateCount(count: number) {
        this.count = count;
        (this.getView() as LandingPageListViewImpl).removeAllTabs();
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void {
        console.log("API Success:", data, !this.isLoadMore);
          this.setState({ isDataNotLoaded: (data as FeaturedCategoryDto).getListOfTones().length === 0 });
        if (!this.isLoadMore) {
            this.count--;

            (this.getView() as LandingPageListViewImpl).updateTabData(
                (data as FeaturedCategoryDto).getCategoryId(),
                this.props.context,
                (data as FeaturedCategoryDto).getTitle(),
                (data as FeaturedCategoryDto).getListOfTones()
            );

            if (this.count <= 0) {
                (this.getView() as LandingPageListViewImpl).dismissLoader();
                (this.getView() as LandingPageListViewImpl).updateTab();
            }
        } else {
            (this.getView() as LandingPageListViewImpl).dismissLoader();

            (this.getView() as LandingPageListViewImpl).updateLoadMoreTabData(
                (data as FeaturedCategoryDto).getTitle(),
                (data as FeaturedCategoryDto).getListOfTones()
            );
            this.setState({ isDataNotLoaded: (data as FeaturedCategoryDto).getListOfTones().length === 0 });
        }

        window.scroll(0, 0);
    }

    onFailure(feature: APIFeatures, description: string, data: any) {
        console.log("API Failure encountered:", description);


        if (!this.isLoadMore) {
            this.count--;
            if (this.count <= 0 && (this.getView() as LandingPageListViewImpl).getListOfTitles().length === 0) {
                (this.getView() as LandingPageListViewImpl).dismissLoader();
                this.setState({ isDataNotLoaded: true });
            }
        } else {
            (this.getView() as LandingPageListViewImpl).dismissLoader();
        }


        window.scroll(0, 0);
    }

    // 5. Protected framework factory methods
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel> {
        return new LandingPageListViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle {
        return new LandingPageListCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel {
        return new LandingPageListAPIModelImpl(applicationContext, apiModelHandler);
    }

    // 6. Private helper methods reside strictly at the bottom
    private initialDataFetch(props = this.props) {
        this.isLoadMore = false;
        this.count = 1;

        (this.getView() as LandingPageListViewImpl).showLoader();

        this.getAPIModel().getLoadMoreFeatureLandingPageTones(props.categoryId || 0, props.categoryName, 0, 20,props.language);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/landingpagelist/landingpagelistcomponent.tsx